import { render, staticRenderFns } from "./EditorMultiplosProdutos.vue?vue&type=template&id=aa9c0d58"
import script from "./EditorMultiplosProdutos.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorMultiplosProdutos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports